import {updateActiveMenu} from '@/actions/setupActions';
import {STATUS} from '@/constants/pcConstAppData';
import {LockStatusPageEvent} from '@/constants/pubSubEnum';
import {eventBusObject} from '@/observers/eventBus';

// eslint-disable-next-line import/prefer-default-export
export function initStatusPage() {
  return (dispatch, getState) => {
    const bus = eventBusObject();
    const {setupStore} = {...getState()};
    const {lockAccess, isPCRunning} = setupStore;

    bus.publish(LockStatusPageEvent.ON_CLICK_LOCK_CONCENTRATOR, {
      isLockAccess: lockAccess,
      isDisabled: !isPCRunning,
    });

    dispatch(updateActiveMenu(STATUS));
  };
}
